import { render, staticRenderFns } from "./MainReportTableView.vue?vue&type=template&id=728e5873&scoped=true&"
import script from "./MainReportTableView.vue?vue&type=script&lang=js&"
export * from "./MainReportTableView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728e5873",
  null
  
)

export default component.exports